import React, { useState, useEffect } from 'react';
import { FloatingPlayer } from '../ui/SongPreview'
import SongPreview from '../ui/SongPreview';
import MusicBrowser from '../ui/MusicBrowser';
import FaIcon from '../../helpers/fa_icon'
import { serializeSong, deserializeSong } from '../../helpers/songSerializer'


const SongPicker = ({ label, title, disabled, suggestionListId, allowCustom, inputId }) => {
  const [currentSong, setCurrentSong] = useState(null);
  const [ready, setReady] = useState(false);

  // When the currentSong changes, sync to the input field
  useEffect(() => {
    const target = document.getElementById(inputId);
    if (target && ready) {
      target.value = serializeSong(currentSong);
    }
  }, [currentSong, ready]);

  // When the component loads, sync from the input field
  useEffect(() => {
    const target = document.getElementById(inputId);
    if (target) {
      setCurrentSong(deserializeSong(target.value));
    }
    setReady(true);
  }, []);


  function handleChange(song) {
    setCurrentSong(song);
  }

  function handleRemove() {
    setCurrentSong(null);
  }

  return (
    <FloatingPlayer>
      { currentSong ?
        <SongPreview
          {...currentSong}
          suggestionListId={suggestionListId}
          allowCustomSongEntry={allowCustom}
          onUpdate={handleChange}
        />
        :
        <MusicBrowser
          label={<FaIcon icon="plus" text={label} />}
          title={title}
          disabled={disabled}
          onChange={handleChange}
          onRemove={handleRemove}
          currentSong={currentSong}
          suggestionListId={suggestionListId}
          allowCustomSongEntry={allowCustom}
        />
      }
    </FloatingPlayer>
  )
}

export default SongPicker;
